module.exports = __webpack_public_path__ + "img/store-connect-banner.17bc7da4.svg";